__turbopack_context__.v({
  "container": "BUdJ_W_container",
  "mobileVideo": "BUdJ_W_mobileVideo",
  "video": "BUdJ_W_video",
});
